import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CurrentUser, CurrentUserState } from './currentUserTypes';

const initialState: Partial<CurrentUserState> = {};

const currentUserSlice = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    fetchCurrentUserSuccess: (state, action: PayloadAction<Partial<CurrentUser>>) => {
      return { ...state, ...action.payload };
    },
    clearCurrentUser: () => {
      return {};
    }
  }
});

export const currentUserReducer = currentUserSlice.reducer;

export const { fetchCurrentUserSuccess, clearCurrentUser } = currentUserSlice.actions;
